import './App.css';
import React, { Suspense, lazy } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import {UserContextProvider} from './context/userContext/userContext'
import PrivateRoutes from './routes/PrivateRoutes';
import axios from 'axios'
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import {Toaster} from 'react-hot-toast'
import Home from './pages/Home/Home';
import Register from './pages/Register/Register';
import Terms from './pages/Terms/Terms';
import Plugins from './pages/Plugins/Plugins'
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy'
import { StyleProvider } from './context/styleContext/styleContext'
import { ShoppingCartProvider } from './context/shoppingCartContext/shoppingCartContext';
import Login from './pages/Login/Login';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import FAQ from './pages/FAQ/FAQ';
import Support from './pages/Support/Support';
import Account from './pages/Account/Account';
import CreateLicense from './components/CreateLicense/CreateLicense';
import InfinityReverb from './pages/InfinityReverb/InfinityReverb';
import PageAnalytics from './DataCollection/PageAnalytics';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import CookieHandler from './components/CookieHandler/CookieHandler';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ProductsPage from './pages/Products/ProductsPage';
import ProductPage from './pages/Product/ProductPage';
import ProductReviewPage from './pages/Product/ProductReviewPage';
import Admin from './pages/Admin/Admin';
import AdminRoutes from './routes/AdminRoutes';
import ShoppingCart from './pages/ShoppingCart/ShoppingCart';
import MyGear from './pages/myGear/MyGear';
//import CheckoutPage from './pages/Checkout/CheckoutPage';
import GainDemo from './pages/GainDemo/GainDemo';
import ReverbLearning from './pages/Learning/Reverb';
import DelayLearning from './pages/Learning/Delay';
import Learning from './pages/Learning/Learning';
import CompressionLearning from './pages/Learning/Compression';
import ChorusLearning from './pages/Learning/Chorus';
import OverdriveLearning from './pages/Learning/Overdrive';
import EQLearning from './pages/Learning/EQ';
import SubConfirmPage from './pages/Subscription/SubConfirmPage';
import DistortionLearning from './pages/Learning/Distortion';
import AllReleases from './pages/AllReleases/AllReleases';
import CompareDistOdFuzz from './pages/Learning/CompareDistOdFuzz';
import ImageRendering from './pages/Admin/ImageRendering'
import { HelmetProvider } from 'react-helmet-async';
import ReturnPolicy from './pages/ReturnPolicy/ReturnPolicy';
import SaturationLearning from './pages/Learning/Saturation';
import LimitingLearning from './pages/Learning/Limiting';
import DeEsserLearning from './pages/Learning/Deesser';
import PhaserLearning from './pages/Learning/Phaser';
import NoiseGateLearning from './pages/Learning/Noisegate';
import FlangerLearning from './pages/Learning/Flanger';
import StereoImagingLearning from './pages/Learning/StereoImaging';
import TremoloLearning from './pages/Learning/Tremolo';
import TransientShaperLearning from './pages/Learning/TransientShaper';
import CompressorVsLimiterLearning from './pages/Learning/CompressorVsLimiter';
import MasteringBasicsLearning from './pages/Learning/MasteringBasics';
import SiteLayout from './components/SiteLayout/SiteLayout';
import VibratoLearning from './pages/Learning/Vibrato';
import GainStagingLearning from './pages/Learning/GainStaging';
import BitcrusherLearning from './pages/Learning/Bitcrusher';
import MultibandCompressionLearning from './pages/Learning/MultibandCompression';
import BusProcessingLearning from './pages/Learning/BusProcessing';
import ClippingVsLimitingLearning from './pages/Learning/ClippingVsLimiting';
import ParallelProcessingLearning from './pages/Learning/ParallellProcessing';
import AutomationInMixingLearning from './pages/Learning/AutomationInMixing';
import SidechainCompressionLearning from './pages/Learning/SidechainCompression';
import DynamicEQLearning from './pages/Learning/DynamicEQ';
import CheckoutConfirmationPage from './pages/CheckoutConfirmation/CheckoutConfirmation';
import CheckoutProcessingPage from './pages/CheckoutProcessing/CheckoutProcessing';
import AdminPromotionsPage from './pages/Admin/AdminPromotions';
import { PromotionsProvider } from './context/promotionsContext/promotionsContext';
import PromotionBanner from './components/PromotionBanner/PromotionBanner';

import EmailTesting from './pages/Admin/EmailTesting';
import FixMuddyMixLearning from './pages/Learning/FixMuddyMix';
import VocalsSitInMixLearning from './pages/Learning/MakeVocalsSitInMix';
import ConsistentAudioLevelsLearning from './pages/Learning/KeepLevelsConsistent';
import PunchyDrumsLearning from './pages/Learning/GetPunchyDrums';
import TightenLowEndLearning from './pages/Learning/TightenLowEnd';
import LouderMixWithoutClippingLearning from './pages/Learning/MixLouderWithoutClipping';
import VocalProcessingChainLearning from './pages/Learning/VocalProcessingChain';
import BestReverbSettingsForVocalsLearning from './pages/Learning/ReverbSettingsForVocals';
import AdminProductsPage from './pages/Admin/AdminProductsPage';
import AdminProductPage from './pages/Admin/AdminProductPage';

const Subscribe = lazy(() => import('./pages/Subscribe/Subscribe'));
const CheckoutPage = lazy(() => import('./pages/Checkout/CheckoutPage'));
const ManageSubscription = lazy(() => import('./pages/Subscription/ManageSubscription'));
if(process.env.NODE_ENV === 'development')
{
   axios.defaults.baseURL = 'http://localhost:8080';
  //axios.defaults.baseURL = 'https://api.parishaudio.com/'
}
else
{
  axios.defaults.baseURL = 'https://api.parishaudio.com/'
}


axios.defaults.withCredentials = true;



function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
    <UserContextProvider>
    {/* <PageAnalytics endpoint={axios.defaults.baseURL + '/record-page-analytics'}> */}
    <StyleProvider>
    <PromotionsProvider>
    <ShoppingCartProvider>
    <CookieHandler />

    <Toaster position='bottom-right' toastOptions={{
    // Global default styles
    duration:3000,
    style: {
      borderRadius: '8px',
      background: '#1f2937', // Dark background
      color: '#f9fafb',       // Light text
      padding: '12px 16px',
      fontSize: '1.3rem',
    },
    success: {
      iconTheme: {
        primary: '#10b981', // Tailwind Emerald-500
        secondary: '#d1fae5',
      },
    },
    error: {
      iconTheme: {
        primary: '#ef4444', // Tailwind Red-500
        secondary: '#fee2e2',
      },
    },
  }} />


      <Routes>
      <Route element={<SiteLayout />}>
      


      <Route element= {<PrivateRoutes />}>

        <Route path="account" element={<Account/>} />
        <Route path="/my-gear" element={<MyGear />} />
        <Route
            path="/checkout"
            element={
              <Suspense fallback={<div>Loading checkout...</div>}>
                <CheckoutPage />
              </Suspense>
            }
          />
        <Route path="/manage-subscriptions" element = {<ManageSubscription />} />
        <Route path="/subscription-confirmation" element = {<SubConfirmPage />} />
        <Route path="/checkout-confirmation" element = {<CheckoutConfirmationPage />} />
        <Route path="/checkout-processing" element = {<CheckoutProcessingPage />} />

        {/* <Route path='/account' element={<Account />} />
        <Route path='/my-gear' element={<MyGear />} />
        <Route path= '/checkout' element = {<CheckoutPage />} />
        <Route path= '/subscription-confirmation' element = {<SubConfirmPage />} /> */}

      </Route>


        <Route element={<AdminRoutes />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/create-license" element={<CreateLicense />} />
          <Route path="/gain-demo" element={<GainDemo />} />
          <Route path="/admin/image-rendering" element = {<ImageRendering />} />
          <Route path="admin/promotions" element = {<AdminPromotionsPage />} />
          <Route path="/admin/products" element={<AdminProductsPage />} />
          <Route path="/admin/products/:productId" element={<AdminProductPage />} />
          <Route path="/admin/email-testing" element={<EmailTesting />} />
        </Route>



        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/all-releases" element={<AllReleases />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/plugins" element={<Plugins />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element = {<ResetPassword/>} />
        <Route path="/learning" element={<Learning />} />
        <Route path="/learning/automation-in-mixing" element={<AutomationInMixingLearning />} />
        <Route path="/learning/bitcrusher" element={<BitcrusherLearning />} />
        <Route path="/learning/bus-processing" element={<BusProcessingLearning />} />
        <Route path="/learning/chorus" element={<ChorusLearning />} />
        <Route path="/learning/clipping-vs-limiting" element={<ClippingVsLimitingLearning />} />
        <Route path="/learning/compare-distortion-overdrive-fuzz" element={<CompareDistOdFuzz />} />
        <Route path="/learning/compression" element={<CompressionLearning />} />
        <Route path="/learning/delay" element={<DelayLearning />} />
        <Route path="/learning/distortion" element={<DistortionLearning />} /> 
        <Route path="/learning/dynamic-eq" element={<DynamicEQLearning />} /> 
        <Route path="/learning/equalization" element={<EQLearning />} />
        <Route path="/learning/limiting" element={<LimitingLearning />} />
        <Route path="/learning/multi-band-compression" element={<MultibandCompressionLearning />} />
        <Route path="/learning/overdrive" element={<OverdriveLearning />} />
        <Route path="/learning/parallel-processing" element={<ParallelProcessingLearning />} />
        <Route path="/learning/reverb" element={<ReverbLearning />} />
        <Route path="/learning/saturation" element={<SaturationLearning />} />
        <Route path="/learning/noise-gate" element={<NoiseGateLearning />} />
        <Route path="/learning/de-esser" element={<DeEsserLearning />} />
        <Route path="/learning/flanger" element={<FlangerLearning />} />
        <Route path="/learning/gain-staging" element={<GainStagingLearning />} />
        <Route path="/learning/stereo-imaging" element={<StereoImagingLearning />} />
        <Route path="/learning/sidechain-compression" element={<SidechainCompressionLearning />} />
        <Route path="/learning/tremolo" element={<TremoloLearning />} />
        <Route path="/learning/vibrato" element={<VibratoLearning />} />
        <Route path="/learning/phaser" element={<PhaserLearning />} />
        <Route path="/learning/transient-shaper" element={<TransientShaperLearning />} />
        <Route path="/learning/compressor-vs-limiter" element={<CompressorVsLimiterLearning />}/>
        <Route path="/learning/mastering-basics" element={<MasteringBasicsLearning />}/>
        <Route path="/learning/fix-muddy-mix" element={<FixMuddyMixLearning />} />
        <Route path="/learning/make-vocals-sit-in-mix" element={<VocalsSitInMixLearning />} />
        <Route path="/learning/how-to-keep-audio-levels-consistent" element={<ConsistentAudioLevelsLearning />} />
        <Route path="/learning/how-to-get-punchy-drums" element={<PunchyDrumsLearning />} />
        <Route path="/learning/how-to-tighten-low-end" element={<TightenLowEndLearning />} />
        <Route path="/learning/how-to-make-a-mix-louder-without-clipping" element={<LouderMixWithoutClippingLearning />} />
        <Route path="/learning/vocal-processing-chain" element={<VocalProcessingChainLearning />} />
        <Route path="/learning/best-reverb-settings-for-vocals" element={<BestReverbSettingsForVocalsLearning />} />
        <Route path="/login" element={<Login />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/products/:sku" element={<ProductPage />} />
        <Route path='/reviews/:itemName' element={<ProductReviewPage />} />
        

        <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>

      </ShoppingCartProvider>
      </PromotionsProvider>
      </StyleProvider>
      {/* </PageAnalytics> */}
      </UserContextProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;

